import { createContext, useContext, useState, useEffect } from 'react'
import { useAuth } from '@/context/AuthContext'
import { subscribeToActiveAnnouncements } from '@/services/announcementService'

const AnnouncementContext = createContext(null)

export function useAnnouncements() {
  const context = useContext(AnnouncementContext)
  if (context === null) {
    console.warn(
      'useAnnouncements called outside AnnouncementProvider, returning default values'
    )
    return {
      announcements: [],
      loading: true
    }
  }
  return context
}

export function AnnouncementProvider({ children }) {
  const { currentUser } = useAuth()
  const [announcements, setAnnouncements] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (!currentUser) {
      setAnnouncements([])
      setLoading(false)
      return
    }

    let unsubscribe = null
    unsubscribe = subscribeToActiveAnnouncements((activeAnnouncements) => {
      setAnnouncements(activeAnnouncements)
      setLoading(false)
    })

    return () => {
      if (unsubscribe) {
        unsubscribe()
      }
    }
  }, [currentUser])

  return (
    <AnnouncementContext.Provider
      value={{
        announcements,
        loading
      }}
    >
      {children}
    </AnnouncementContext.Provider>
  )
}

